/**
 * External Dependencies
 */
import 'jquery';
import 'select2';
import Headroom from 'headroom.js';
import { Loader } from '@googlemaps/js-api-loader';

// Expose jQuery globally
window.$ = window.jQuery = jQuery;

import { debounce } from './util';
import Charts from './charts.js';
import Treemaps from './treemaps';
import languages from './json/languages.json';
import industries from './json/industries.json';
import roles from './json/roles.json';

import custom from './custom.js';
import { initContentAnchors } from './contentAnchors';
import accordion from './accordion';

const googleLoader = new Loader({
  apiKey: 'AIzaSyA1alDoXSzJ1R3AXPUYM4wCQwgqgZspHLs',
  version: 'weekly',
  libraries: ['places'],
});

const selectDataObjects = {
  industries,
  roles,
};

const app = {
  init() {
    window.onresize = debounce(() => {
      Charts.init();
      Treemaps.init();
    }, 100);

    if (!location.origin) {
      location.origin = location.protocol + '//' + location.host;
    }
    window.wpajax = location.origin + '/wp-admin/admin-ajax.php';

    try {
      app.stripe = location.host.includes('local')
        ? Stripe('pk_test_CE0IsQx1xmvLg7F3qWADSy5b') // Modalità test
        : Stripe('pk_live_P22Q6g2cgjEEvgzOPrRcX9ML'); // Modalità live
    } catch (error) {
      // fold to test
      console.log('errore stripe');
      app.stripe = Stripe('pk_test_CE0IsQx1xmvLg7F3qWADSy5b'); // Modalità test
    }

    app.onNavigationClick();

    custom.customSlide();

    Charts.init();
    Treemaps.init();
    app.initPopups();
    app.initGenericSelect();
    app.initLanguageSelect();
    app.initInterestSelect();
    app.initUserForms();
    app.initHeadroom();
    app.newsletterSubscription();
    app.reportSubscription();
    app.createAnchors();
    app.initAccordion();
    app.initAnchorScroll();
    app.initSession();
    app.initZoomRegistration();
    app.initNewsletterVideo();
    app.initContactForm();
    app.initGoBackToPreviousPageClick();
    app.initWooCommerce();
    app.initWebGlobalizationReport();
  },
  createAnchors() {
    initContentAnchors(document);
  },
  initAccordion() {
    accordion.initAccordion(document);
  },
  initAnchorScroll() {
    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const minOffset = 96;
    const maxOffset = 360;

    const getOffset = () => {
      const offset = Math.round(window.innerHeight / 3);
      return Math.min(Math.max(offset, minOffset), maxOffset);
    };

    const getTarget = (hash) => {
      if (!hash || hash.length < 2) {
        return null;
      }
      const id = decodeURIComponent(hash.slice(1));
      if (!id) {
        return null;
      }
      return document.getElementById(id);
    };

    const scrollToHash = (hash, options = {}) => {
      const target = getTarget(hash);
      if (!target) {
        return false;
      }

      const offset = getOffset();
      const top = Math.max(
        0,
        target.getBoundingClientRect().top + window.pageYOffset - offset,
      );

      window.scrollTo({
        top,
        behavior:
          options.behavior ||
          (prefersReducedMotion ? 'auto' : 'smooth'),
      });

      if (options.updateUrl) {
        history.pushState(null, '', hash);
      }

      return true;
    };

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented) {
        return;
      }

      const link = event.target.closest('a[href^="#"]');
      if (!link) {
        return;
      }

      const href = link.getAttribute('href');
      if (!href || href === '#' || href === '#0') {
        return;
      }

      if (link.hasAttribute('data-popup')) {
        return;
      }

      const url = new URL(link.href, window.location.href);
      if (
        url.origin !== window.location.origin ||
        url.pathname !== window.location.pathname
      ) {
        return;
      }

      const handled = scrollToHash(url.hash, { updateUrl: true });
      if (handled) {
        event.preventDefault();
      }
    });

    if (window.location.hash) {
      window.setTimeout(() => {
        scrollToHash(window.location.hash, { behavior: 'auto' });
      }, 0);
    }

    window.addEventListener('hashchange', () => {
      if (!window.location.hash) {
        return;
      }
      scrollToHash(window.location.hash);
    });
  },
  newsletterSubscription() {
    $('form#newsletter-signup, form#newsletter').on('submit', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]', $form);
      const isLanding = $form.attr('id') === 'newsletter-signup';

      if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits
      const submitData = {
        action: 'subscribe_newsletter',
        name: this.name.value,
        email: this.email.value,
        language: this.language.value,
        industry: this.industry.value,
        role: this.role_other.value || this.role.value,
        subscribe: isLanding
          ? this.subscribe.checked
            ? this.subscribe.value
            : ''
          : 'on',
        referral: sessionStorage.getItem('referral') || '',
        security: this.newslettersecurity.value,
      };

      $submitBtn.attr('disabled', 'disabled').addClass('disabled');
      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.wpajax,
        data: submitData,
        success: function () {
          const message = `Thanks for signing up${
            isLanding ? ', check your inbox to download the report.' : '.'
          }`;

          const expireDate = new Date();
          expireDate.setMonth(expireDate.getMonth() + 1);
          document.cookie = `imm_no_nl=true; expires=${expireDate.toUTCString()};`;

          $form.addClass('success');
          $status.html(message).addClass('visible');
          $submitBtn.removeAttr('disabled').removeClass('disabled');
          // Reset form
          $form.trigger('reset');
          $form
            .find('#language')
            .val(null)
            .trigger('change')
            .removeClass('selected');
          $form
            .find('#industry')
            .val(null)
            .trigger('change')
            .removeClass('selected');
          $form
            .find('#role')
            .val(null)
            .trigger('change')
            .removeClass('selected');
        },
        error: (error) => {
          console.error(error.statusText);
          $status
            .html(
              '<span class="error">Something went wrong, please try again...</span>',
            )
            .addClass('visible');
          $submitBtn.removeAttr('disabled').removeClass('disabled');
        },
      });

      return false;
    });
  },
  submitReportForm(submitData, $form, $status, $submitBtn) {
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: window.wpajax,
      data: submitData,
      success: function () {
        // Show response message
        const message =
          "Thanks for requesting the Annual Report, we'll get in touch as soon as possible to finalise your shipping.";

        $form.addClass('success');
        $status.html(message).addClass('visible');
        $submitBtn.removeAttr('disabled').removeClass('disabled');
        // Reset form
        $form.trigger('reset');
        $form
          .find('#reportinterest')
          .val(null)
          .trigger('change')
          .removeClass('selected');
        $form
          .find('#reportindustry')
          .val(null)
          .trigger('change')
          .removeClass('selected');
        $form.find('#size').val(null).trigger('change').removeClass('selected');
        $form
          .find('#reportrole')
          .val(null)
          .trigger('change')
          .removeClass('selected');
        //$('.js-price').html('$ 99');
      },
      error: function (error) {
        console.error(error.statusText);
        $status
          .html(
            '<span class="error">Something went wrong, please try again...</span>',
          )
          .addClass('visible');
        $submitBtn.removeAttr('disabled').removeClass('disabled');
      },
    });
  },
  writeReportOrder(submitData) {
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: window.wpajax,
      data: {
        ...submitData,
        ...submitData.originalAddress,
        action: 'write_googlesheet',
        datetime: `${new Date().toLocaleDateString('it', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          timeZone: 'CET',
        })} ${new Date().toLocaleTimeString('it', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZone: 'CET',
        })}`,
      },
      success: function (result) {
        console.log('DEBUG --> google sheets response:', result);
      },
      error: function (error) {
        console.error(error);
      },
    });
  },
  openAddressAlert(targetInput) {
    const modal = document.querySelector('.js-address-alert');
    if (!modal) {
      return;
    }
    app.addressAlertFocusTarget = targetInput || null;
    document.body.classList.forEach((className) => {
      if (className.startsWith('popup-')) {
        document.body.classList.remove(className);
      }
    });
    document.body.classList.add('popup-address-alert');
  },
  closeAddressAlert() {
    document.body.classList.forEach((className) => {
      if (className.startsWith('popup-')) {
        document.body.classList.remove(className);
      }
    });
    if (
      app.addressAlertFocusTarget &&
      document.body.contains(app.addressAlertFocusTarget)
    ) {
      app.addressAlertFocusTarget.focus();
    }
    app.addressAlertFocusTarget = null;
  },
  initAutocomplete() {
    if (!app.addressAlertInitialized) {
      app.addressAlertInitialized = true;
      document.addEventListener('click', (event) => {
        const closeButton = event.target.closest('.js-address-alert-close');
        if (!closeButton) return;
        event.preventDefault();
        app.closeAddressAlert();
      });
    }

    // Load Google API for autocomplete
    googleLoader
      .load()
      .then((google) => {
        // Init autocomplete
        app.autocompleteInputs = document.querySelectorAll(
          '.js-address-input input',
        );

        app.autocompleteInputs.forEach((input) => {
          const form = input.closest('.js-address-container');

          // Create the field structure to pass as param of the fillShippingAddress
          // This function used for the followinf forms:
          // - requesto report (old)
          // - woocommerce shipping
          // - woocommerce billing
          const addressFields = {
            address: input,
            autocompleted:
              form.querySelector('input[name="billing_address_autocompleted"]') ||
              form.querySelector('input[name="shipping_address_autocompleted"]'),
            info:
              form.querySelector('input[name="address2"]') ||
              form.querySelector('input[name="billing_address_2"]') ||
              form.querySelector('input[name="shipping_address_2"]'),
            streetNumber:
              form.querySelector('input[name="street_number"]') ||
              form.querySelector('input[name="billing_house_number"]') ||
              form.querySelector('input[name="shipping_house_number"]'),
            postCode:
              form.querySelector('input[name="postcode"]') ||
              form.querySelector('input[name="billing_postcode"]') ||
              form.querySelector('input[name="shipping_postcode"]'),
            locality:
              form.querySelector('input[name="locality"]') ||
              form.querySelector('input[name="billing_city"]') ||
              form.querySelector('input[name="shipping_city"]'),
            // WooCommerce swaps this node on every country change (select for
            // countries with states, hidden input otherwise), so it is looked
            // up again through `form` whenever it is written to.
            form,
            state: app.resolveStateField(form),
            country:
              form.querySelector('input[name="country"]') ||
              form.querySelector('select[name="billing_country"]') ||
              form.querySelector('select[name="shipping_country"]'),
          };

          const isSelectCountry =
            addressFields.country &&
            addressFields.country.tagName === 'SELECT';

          const inputWrapper = input.closest('.input-wrap');
          const extraFieldInputs = [
            addressFields.streetNumber,
            addressFields.info,
            addressFields.postCode,
            addressFields.locality,
          ];

          // The WooCommerce state field is shown and hidden by WooCommerce
          // itself, and its node is replaced on every country change: only the
          // report form's own state input joins the lock/unlock cycle.
          if (addressFields.state && addressFields.state.name === 'state') {
            extraFieldInputs.push(addressFields.state);
          }

          if (
            addressFields.country &&
            addressFields.country.tagName !== 'SELECT'
          ) {
            extraFieldInputs.push(addressFields.country);
          }

          const extraFields = extraFieldInputs.filter(Boolean).map((field) => {
            const wrapper = field.closest('.input-wrap');
            return {
              input: field,
              wrapper,
              hiddenAttr: wrapper ? wrapper.hasAttribute('hidden') : false,
              hiddenClass: wrapper ? wrapper.classList.contains('hidden') : false,
            };
          });

          let autocomplete = null;
          let isAutocompleted = false;
          let lastAutocompletedValue = '';
          let blurTimeout = null;

          const getAutocompletedState = () =>
            addressFields.autocompleted
              ? addressFields.autocompleted.value === '1'
              : isAutocompleted;

          const setAutocompletedState = (value, options = {}) => {
            isAutocompleted = value;
            if (addressFields.autocompleted) {
              addressFields.autocompleted.value = value ? '1' : '0';
            }
            if (value && !options.skipValue) {
              lastAutocompletedValue = input.value.trim();
            }
            if (!value) {
              lastAutocompletedValue = '';
            }
          };

          const toggleExtraFields = (enabled) => {
            extraFields.forEach(
              ({
                input: extraInput,
                wrapper,
                hiddenAttr,
                hiddenClass,
              }) => {
                if (!extraInput) return;
                extraInput.disabled = !enabled;
                if (enabled) {
                  extraInput.removeAttribute('disabled');
                } else {
                  extraInput.setAttribute('disabled', 'disabled');
                }
                if (wrapper) {
                  if (enabled) {
                    if (hiddenAttr) wrapper.removeAttribute('hidden');
                    if (hiddenClass) wrapper.classList.remove('hidden');
                  } else {
                    if (hiddenAttr) wrapper.setAttribute('hidden', '');
                    if (hiddenClass) wrapper.classList.add('hidden');
                  }
                }
              },
            );

            if (inputWrapper) {
              if (enabled) {
                inputWrapper.classList.add('form-grid__almostfullwidth');
                inputWrapper.classList.remove('form-grid__fullwidth');
              } else {
                inputWrapper.classList.add('form-grid__fullwidth');
                inputWrapper.classList.remove('form-grid__almostfullwidth');
              }
            }
          };

          const clearExtraFields = () => {
            extraFields.forEach(({ input: extraInput }) => {
              if (!extraInput) return;
              extraInput.value = '';
              extraInput.dispatchEvent(new Event('change'));
              extraInput.dispatchEvent(new Event('input'));
            });

            // The WooCommerce state field is out of `extraFields`, but a stale
            // state must not survive an address the customer is retyping.
            const stateField = app.resolveStateField(form);

            if (stateField && stateField.name !== 'state') {
              stateField.value = '';
              stateField.dispatchEvent(new Event('change', { bubbles: true }));
            }
          };

          const lockAddressFields = ({ clearValues = false } = {}) => {
            if (clearValues) {
              clearExtraFields();
            }
            toggleExtraFields(false);
          };

          const unlockAddressFields = () => {
            toggleExtraFields(true);
          };

          const validateAddressInput = () => {
            const hasValue = input.value.trim() !== '';
            const isValid = getAutocompletedState();

            if (hasValue && !isValid) {
              lockAddressFields();
              app.openAddressAlert(input);
              return;
            }

            if (hasValue && isValid) {
              unlockAddressFields();
              return;
            }

            lockAddressFields();
          };

          const setupAutocomplete = (countryCode = '') => {
            if (autocomplete) return; // Already set up
            const autocompleteOptions = {
              fields: ['address_components', 'geometry'],
              types: ['address'],
            };
            if (countryCode) {
              autocompleteOptions.componentRestrictions = {
                country: countryCode,
              };
            }
            autocomplete = new google.maps.places.Autocomplete(
              input,
              autocompleteOptions,
            );
            autocomplete.addListener('place_changed', () => {
              unlockAddressFields();
              app.fillShippingAddress(
                autocomplete.getPlace(),
                addressFields,
              );
              setAutocompletedState(true);
            });
          };

          const updateAddressInput = () => {
            const selectedCountry = isSelectCountry
              ? addressFields.country.value.trim()
              : '';
            if (selectedCountry) {
              // Enable input and set up autocomplete if not already
              input.disabled = false;
              setupAutocomplete(selectedCountry);
              if (autocomplete) {
                autocomplete.setComponentRestrictions({
                  country: selectedCountry,
                });
              }
              // Update placeholder
              const countryName = addressFields.country.selectedIndex > 0
                ? addressFields.country.options[addressFields.country.selectedIndex].text
                : '';
              //input.placeholder = `Enter address in ${countryName}`;
            } else {
              // Disable input
              input.disabled = true;
              // input.placeholder = 'Please select a country first';
              if (autocomplete) {
                // Note: Google Places Autocomplete doesn't have a destroy method, so we just disable the input
              }
              setAutocompletedState(false);
              lockAddressFields({ clearValues: true });
            }
          };

          input.addEventListener('input', () => {
            const currentValue = input.value.trim();
            const isValid = getAutocompletedState();

            if (isValid && currentValue === lastAutocompletedValue) {
              return;
            }

            setAutocompletedState(false);
            lockAddressFields({ clearValues: true });
          });

          input.addEventListener('focus', () => {
            if (blurTimeout) {
              clearTimeout(blurTimeout);
            }
          });

          input.addEventListener('blur', () => {
            if (blurTimeout) {
              clearTimeout(blurTimeout);
            }
            blurTimeout = setTimeout(() => {
              validateAddressInput();
            }, 150);
          });

          lockAddressFields();

          if (isSelectCountry) {
            // Always disable initially to force country selection
            input.disabled = true;
            // input.placeholder = 'Please select a country first';
            // Listen for changes
            addressFields.country.addEventListener('change', updateAddressInput);
            $(addressFields.country).on('select2:select', updateAddressInput);
            // Handle initial state if country is already selected
            updateAddressInput();
          } else {
            // No country select, set up autocomplete without restrictions
            setupAutocomplete();
            input.placeholder = 'Enter a location';
          }
        });
      })
      .catch((e) => {
        console.error('Error loading Google Maps APIs', e);
      });
  },
  /*
   * Look up the state field of a form.
   *
   * On the checkout this is the native WooCommerce field, which alternates
   * between a <select> of state codes, a hidden input and a text input as the
   * country changes — so it must never be cached across a country change.
   */
  resolveStateField(form) {
    if (!form) return null;

    return form.querySelector(
      '[name="state"], [name="billing_state"], [name="shipping_state"]',
    );
  },
  /*
   * Write the state, matching what the form on screen expects.
   *
   * WooCommerce keys tax rates and shipping zones by the 2-letter code, so the
   * checkout gets `short_name`; the report form shows the value to the user, so
   * it keeps the readable `long_name`.
   */
  fillStateField(fields, component) {
    const stateField = app.resolveStateField(fields.form) || fields.state;

    if (!stateField) return;

    const isWooField = /^(billing|shipping)_state$/.test(stateField.name);

    // WooCommerce turns the field into a hidden input for every country it
    // holds no states for: those orders must carry no state at all, so the
    // value is dropped instead of being written and stripped later on.
    if (isWooField && stateField.type === 'hidden') {
      stateField.value = '';
      stateField.dispatchEvent(new Event('change', { bubbles: true }));
      fields.state = stateField;
      return;
    }

    const value = isWooField ? component.short_name : component.long_name;

    stateField.value = value;

    // A <select> silently ignores a value with no matching option, which would
    // leave the field empty: fall back to matching the option by its label.
    if (stateField.tagName === 'SELECT' && stateField.value !== value) {
      const match = Array.from(stateField.options).find(
        (option) =>
          option.value === value ||
          option.text.toLowerCase() === component.long_name.toLowerCase(),
      );

      if (match) {
        stateField.value = match.value;
      }
    }

    stateField.dispatchEvent(new Event('change', { bubbles: true }));
    stateField.dispatchEvent(new Event('input', { bubbles: true }));

    // Keep the cached reference pointing at the node currently in the DOM.
    fields.state = stateField;
  },
  fillShippingAddress(currentPlace, fields) {
    if (currentPlace) {
      // Autofill address details
      const place = currentPlace;
      let postcode = '';

      // Set autocompleted flag
      if (fields.autocompleted) {
        fields.autocompleted.value = '1';
      }

      //Reset fields
      for (const fieldName in fields) {
        if (
          fieldName !== 'address' &&
          fieldName !== 'autocompleted' &&
          fieldName !== 'form' &&
          fields[fieldName]
        ) {
          fields[fieldName].value = '';
          fields[fieldName].dispatchEvent(new Event('change'));
          fields[fieldName].dispatchEvent(new Event('input'));
        }
      }

      // The country has to be applied before the state: it arrives *after*
      // `administrative_area_level_1` in `address_components`, and WooCommerce
      // only builds the state field once it knows the country.
      const countryComponent = place.address_components.find((component) =>
        component.types.includes('country'),
      );

      if (countryComponent && fields.country) {
        fields.country.value = countryComponent.short_name;
        fields.country.dispatchEvent(new Event('change', { bubbles: true }));
        fields.country.dispatchEvent(new Event('input', { bubbles: true }));
      }

      //Populate address fields
      for (const component of place.address_components) {
        const componentType = component.types[0];

        switch (componentType) {
          case 'street_number': {
            if (fields.streetNumber) {
              fields.streetNumber.value = component.long_name;
              fields.streetNumber.dispatchEvent(new Event('input'));
            }
            break;
          }
          case 'route': {
            fields.address.value = component.short_name;
            break;
          }
          case 'postal_code': {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case 'postal_code_suffix': {
            postcode = `${postcode}-${component.long_name}`;
            break;
          }
          case 'locality':
            if (fields.locality) {
              fields.locality.value = component.long_name;
              fields.locality.dispatchEvent(new Event('input'));
            }
            break;
          case 'administrative_area_level_1': {
            app.fillStateField(fields, component);
            break;
          }
          // `country` is intentionally not handled here: it is applied before
          // this loop so WooCommerce can build the state field first.
        }
      }
      fields.postCode.value = postcode;
      fields.postCode.dispatchEvent(new Event('input'));
    }

    // After filling the form with address components from the Autocomplete
    // prediction, set cursor focus on the second address line to encourage
    // entry of subpremise information such as apartment, unit, or floor number.
    if (fields.streetNumber.value) {
      // document.querySelector('#address2').focus();
      fields.info.focus();
    } else {
      fields.streetNumber.focus();
    }
  },
  reportSubscription() {
    const $form = $('form#report-signup');

    if ($form.length > 0) {
      app.initAutocomplete();
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]');

      app.initStripe($status, $submitBtn);

      $form.on('submit', function (e) {
        e.preventDefault();

        if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits

        const originalAddress = {};
        originalAddress.address1 = this.ship_address.value.trim();
        originalAddress.streetNumber = this.street_number.value.trim();
        originalAddress.address2 = this.address2.value.trim();
        originalAddress.locality = this.locality.value.trim();
        originalAddress.postcode = this.postcode.value.trim();
        originalAddress.state = this.state.value.trim();
        originalAddress.country = this.country.value.trim();
        const address = `${originalAddress.address1} ${
          originalAddress.streetNumber
        }${originalAddress.address2 ? ` - ${originalAddress.address2}` : ''}, ${
          originalAddress.postcode
        } ${originalAddress.locality}, ${originalAddress.state}, ${
          originalAddress.country
        }`;
        const submitData = {
          action: 'request_report',
          interest:
            this.reportinterest_other.value || this.reportinterest.value,
          industry: this.reportindustry.value,
          company: this.company.value,
          role: this.reportrole_other.value || this.reportrole.value,
          firstname: this.firstname.value.trim(),
          lastname: this.lastname.value.trim(),
          name: `${this.firstname.value} ${this.lastname.value}`,
          address,
          originalAddress,
          email: this.email.value.trim(),
          subscribe: this.subscribe.checked ? this.subscribe.value : '',
          referral: sessionStorage.getItem('referral') || '',
          security: this.reportsecurity.value,
          payment: 'Not paid',
          year: `${$form.data('report-year')}`,
          spreadsheetId: `${$form.data('report-sheet')}`,
        };

        if (
          submitData.firstname === '' ||
          submitData.lastname === '' ||
          originalAddress.address1 === '' ||
          originalAddress.streetNumber === '' ||
          originalAddress.locality === '' ||
          originalAddress.postcode === '' ||
          originalAddress.state === '' ||
          originalAddress.country === '' ||
          submitData.email === ''
        ) {
          $status
            .html(`<span class="error">All fields are mandatory</span>`)
            .addClass('visible');
          return false;
        }

        // Write submission to Google Sheets
        if (submitData.spreadsheetId === '') {
          $status
            .html(
              `<span class="error">Configuration Error. We're unable to process your request, please <a href="mailto:imminent@translated.com">contact us</a> for assistance.</span>`,
            )
            .addClass('visible');
          return false;
        }

        $submitBtn.attr('disabled', 'disabled').addClass('disabled');

        if (app.shouldPayReport) {
          // If the card requires authentication Stripe shows a pop-up modal to
          // prompt the user to enter authentication details without leaving your page.
          app.stripe
            .confirmCardPayment(app.clientSecret, {
              payment_method: {
                card: app.card,
              },
            })
            .then(function (result) {
              if (result.error) {
                // Show error to your customer
                $status
                  .html(`<span class="error">${result.error.message}</span>`)
                  .addClass('visible');
                $submitBtn.removeAttr('disabled').removeClass('disabled');
              } else {
                // The payment succeeded!
                // Submit the form to mailchimp
                submitData.payment = 'Paid with Stripe';
                submitData.paymentId = result.paymentIntent.id;
                app.writeReportOrder(submitData);
                app.submitReportForm(submitData, $form, $status, $submitBtn);
              }
            });
        } else {
          // Submit the form to mailchimp
          submitData.payment = 'No payment needed';
          app.writeReportOrder(submitData);
          app.submitReportForm(submitData, $form, $status, $submitBtn);
        }

        return false;
      });
    }
  },
  onNavigationClick() {
    const hamburger = document.querySelector('#nav-hamburger');
    const mobileNavigation = document.querySelector('#nav');
    hamburger &&
      hamburger.addEventListener('click', function () {
        hamburger.classList.toggle('is-active');
        mobileNavigation.classList.toggle('is-active');
      });
  },
  initPopups() {
    const overlay = document.querySelector('#popup-overlay');
    const toggles = document.querySelectorAll('[data-popup]');
    const closeButtons = document.querySelectorAll('.popup__close');
    const scrollToggle = document.querySelector('[data-popup-onscroll]');
    const hasCookie = document.cookie
      .split('; ')
      .some((row) => row.startsWith('imm_no_nl='));
    const hasAlreadyDeclined = sessionStorage.getItem('imm_no_nl');
    const newsletter = window.location.hash.slice(1) === 'newsletter';
    const isCountryPage = window.location.pathname.includes('data-index/');

    overlay &&
      overlay.addEventListener('click', () => {
        document.body.classList.forEach((className) => {
          if (className.startsWith('popup-')) {
            document.body.classList.remove(className);
          }
        });
      });

    closeButtons.forEach((button) => {
      button &&
        button.addEventListener('click', (e) => {
          e.preventDefault();
          document.body.classList.forEach((className) => {
            if (className.startsWith('popup-')) {
              document.body.classList.remove(className);
            }
          });
        });
    });

    toggles.forEach((toggle) => {
      const targetId = toggle.getAttribute('data-popup');
      toggle &&
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          document.body.classList.forEach((className) => {
            if (className.startsWith('popup-')) {
              document.body.classList.remove(className);
            }
          });
          document.body.classList.add(`popup-${targetId}`);
          if (targetId === 'search') {
            $(`.${targetId}`).find('input').focus();
          }
        });
    });

    if (!hasCookie && !hasAlreadyDeclined && scrollToggle && !isCountryPage) {
      const targetId = scrollToggle.getAttribute('data-popup-onscroll');
      $(window).one('scroll', function () {
        setTimeout(function () {
          // Set session flag
          sessionStorage.setItem('imm_no_nl', 'true');
          // Open popup
          document.body.classList.forEach((className) => {
            if (className.startsWith('popup-')) {
              document.body.classList.remove(className);
            }
          });
          document.body.classList.add(`popup-${targetId}`);
        }, 1000);
      });
    }

    if ($('section.changepass').length > 0) {
      document.body.classList.forEach((className) => {
        if (className.startsWith('popup-')) {
          document.body.classList.remove(className);
        }
      });
      document.body.classList.add('popup-changepass');
    }

    if (newsletter) {
      document.body.classList.forEach((className) => {
        if (className.startsWith('popup-')) {
          document.body.classList.remove(className);
        }
      });
      document.body.classList.add('popup-newsletter');
    }
  },
  initGenericSelect() {
    const $selects = $('.js-select-generic');
    $selects.each((i, item) => {
      const $select = $(item);
      const data = $select.data('object')
        ? selectDataObjects[$select.data('object')]
        : null;
      const $input = $select.siblings('.js-input');
      $select.select2({
        data,
        placeholder: $select.siblings('label').text(),
        theme: 'material',
        dropdownParent: $select.parent(),
        minimumResultsForSearch: 15,
      });
      $select.on('select2:select', function (e) {
        $select.addClass('selected');
        if ($input.length > 0) {
          $input
            .prop(
              'hidden',
              e.params.data.id !== 'Others' && e.params.data.id !== 'Other',
            )
            .prop(
              'required',
              e.params.data.id === 'Others' || e.params.data.id === 'Other',
            )
            .focus();
        }
      });
    });
  },
  initCheckoutCountryAlert() {
    const alert = document.querySelector('.js-country-alert');
    if (!alert) {
      return;
    }

    const updateAlertVisibility = () => {
      const billingCountry = document.querySelector(
        'select[name="billing_country"]',
      );
      const shippingCountry = document.querySelector(
        'select[name="shipping_country"]',
      );
      const hasSelection =
        (billingCountry && billingCountry.value.trim() !== '') ||
        (shippingCountry && shippingCountry.value.trim() !== '');

      if (hasSelection) {
        alert.setAttribute('hidden', '');
      } else {
        alert.removeAttribute('hidden');
      }
    };

    updateAlertVisibility();

    const $body = $('body');
    $body.on(
      'change',
      'select[name="billing_country"], select[name="shipping_country"]',
      updateAlertVisibility,
    );
    $body.on(
      'select2:select select2:clear',
      'select[name="billing_country"], select[name="shipping_country"]',
      updateAlertVisibility,
    );
    $body.on('updated_checkout', updateAlertVisibility);
  },
  initWooCommerce() {
    const $form = $('form[name="checkout"]');
    if ($form.length > 0) {
      app.initAutocomplete();
      app.initCheckoutCountryAlert();
    }
    //Since we're unable to modify the WooCommerce markup for input and label, we need to manage the label animation programmatically
    // Delegated rather than bound per field: WooCommerce replaces the state
    // field node on every country change, and a directly bound handler would
    // stay attached to the discarded node, leaving the label over the value.
    const labelFieldsSelector = '.input-wrap.input-wrap--reverse :input';

    const syncFilledLabel = (input) => {
      const $input = $(input);
      const $parent = $input.closest('.input-wrap');

      if (!$parent.length) return;

      $parent.toggleClass('filled', Boolean($input.val()));
    };

    const syncAllFilledLabels = () => {
      $(labelFieldsSelector).each(function () {
        syncFilledLabel(this);
      });
    };

    syncAllFilledLabels();

    $('body')
      .on('focus', labelFieldsSelector, function () {
        $(this).closest('.input-wrap').addClass('focus');
      })
      .on('blur', labelFieldsSelector, function () {
        $(this).closest('.input-wrap').removeClass('focus');
      })
      .on('input change select2:select', labelFieldsSelector, function () {
        syncFilledLabel(this);
      })
      // Fired once WooCommerce has rebuilt the state field for a new country.
      .on('country_to_state_changed updated_checkout', syncAllFilledLabels);

    // Checkout form
    $('body').on('updated_checkout', function () {
      /* ------- Add custom coupon form ------- */
      $('.coupon-form').css('display', 'none');

      $('.checkout-coupon-toggle .show-coupon').on('click', function (e) {
        e.preventDefault();

        $('.coupon-form').toggle(200);
        $('.coupon-form input[name="coupon_code"]').trigger('focus');
      });

      $('.coupon-form input[name="coupon_code"]').on(
        'input change',
        function () {
          $('form.checkout_coupon input[name="coupon_code"]').val(
            $(this).val(),
          );
        },
      );

      $('.coupon-form button[name="apply_coupon"]').on('click', function () {
        $('form.checkout_coupon').trigger('submit');
      });
      /* --------------------------------------- */

      /* ---- Read referral from sessionStorage ---- */
      const input = $('input[name="newsletter_referral"]');
      if (input.length > 0) {
        const value = sessionStorage.getItem('referral') || '';
        $(input).val(value);
      }
      /* ------------------------------------------- */
    });
  },
  initLanguageSelect() {
    const $selects = $('.js-select-language');
    $selects.each((i, item) => {
      const $select = $(item);
      const selected = $select.data('selected-option');
      const languagesData = selected
        ? languages.map((item) => {
            return item.id === selected ? { ...item, selected: true } : item;
          })
        : [...languages];
      $select.select2({
        data: languagesData,
        placeholder: $select.siblings('label').text(),
        theme: 'material',
        dropdownParent: $select.parent(),
        minimumResultsForSearch: 15,
      });
      $select.on('select2:select', function () {
        $select.addClass('selected');
      });
      if (selected) $select.addClass('selected');
    });
  },
  /*
  handleInterestChange($price, $cardWrapper, $buttonLabel, selectedValue) {
    if (selectedValue === 'Localization provider') {
      app.shouldPayReport = true;
      $cardWrapper.show();
      $buttonLabel.text($buttonLabel.data('pay-label'));
      $price.html('$ 99');
      const $industrySelect = $('.js-select-industry');
      $industrySelect.val('Translation and localization');
      $industrySelect.trigger('change').addClass('selected');
    } else {
      app.shouldPayReport = false;
      $cardWrapper.hide();
      $buttonLabel.text($buttonLabel.data('default-label'));
      $price.html('<span class="strike">$ 99</span> $ 0');
    }
  },
  */
  initInterestSelect() {
    const $select = $('.js-select-interest');
    //const $price = $('.js-price');
    //const $cardWrapper = $('.js-stripe-payment');
    //const $buttonLabel = $('.js-submit-label');

    const urlParams = new URLSearchParams(window.location.search);
    const preSelect =
      urlParams.has('localization_buyer') || urlParams.has('lsp')
        ? 'Localization buyer'
        : urlParams.has('startup')
        ? 'Startup or enterprise'
        : false;

    app.shouldPayReport = false; // Remove when re-enabling payment
    /*
    $select.on('select2:select', function (e) {
      app.handleInterestChange(
        $price,
        $cardWrapper,
        $buttonLabel,
        e.params.data.id,
      );
    });
    */
    if (preSelect) {
      $select.val(preSelect).trigger('change').addClass('selected');
      //app.handleInterestChange($price, $cardWrapper, $buttonLabel, preSelect);
    }
  },
  initUserForms() {
    // login/register forms
    $('form#login, form#register').on('submit', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]', $form);
      const isLogin = $form.attr('id') === 'login';

      if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits
      const currentLanguage =
        !isLogin && languages.find((l) => l.id === this.signonlanguage.value);
      const submitData = {
        action: `ajax${$form.attr('id')}`,
        username: isLogin ? this.username.value : this.signonusername.value,
        password: isLogin ? this.password.value : this.signonpassword.value,
        email: isLogin ? '' : this.signonemail.value,
        security: isLogin ? this.security.value : this.signonsecurity.value,
        subscribe: isLogin
          ? ''
          : this.subscribe.checked
          ? this.subscribe.value
          : '',
        language: isLogin ? '' : currentLanguage.text,
        industry: isLogin ? '' : this.signonindustry.value,
        role: isLogin ? '' : this.signonrole.value,
        referral: sessionStorage.getItem('referral') || '',
      };

      $submitBtn.attr('disabled', 'disabled').addClass('disabled');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.wpajax,
        data: submitData,
        success: function (data) {
          $status.html(data.message).addClass('visible');
          $submitBtn.removeAttr('disabled').removeClass('disabled');
          if (data.loggedin !== false) {
            $status.html(
              isLogin
                ? 'Login successful. You will be redirect shortly...'
                : 'Sign up successful. You will be redirect shortly...',
            );
            const newhref = $("input[name='_wp_http_referer']")
              .val()
              .replace(/\?.*/, '');
            const timeout = isLogin ? 500 : 1000;

            setTimeout(function () {
              document.location.href = newhref;
            }, timeout);
          }
        },
      });

      return false;
    });

    // reset password form
    $('form#resetPassword').on('submit', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]', $form);

      if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits

      const submitData = {
        action: 'lost_pass',
        nonce: this.user_lost_password_nonce.value,
        user_login: this.user_login.value,
        back_url: this.back_url.value,
      };

      $submitBtn.attr('disabled', 'disabled').addClass('disabled');

      $.post(window.wpajax, submitData, function (data) {
        $submitBtn.removeAttr('disabled').removeClass('disabled');
        $status
          .html(
            data == 0
              ? '<span class="error">The provided email address is not associated to any user</span>'
              : data,
          )
          .addClass('visible');
      });

      return false;
    });

    // change password form
    $('form#changePassword').on('submit', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]', $form);

      if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits

      const submitData = {
        action: 'reset_pass',
        nonce: this.user_reset_password_nonce.value,
        pass1: this.pass1.value,
        pass2: this.pass2.value,
        user_key: this.user_key.value,
        user_login: this.user_login.value,
      };

      if (submitData.pass1 === submitData.pass2) {
        $submitBtn.attr('disabled', 'disabled').addClass('disabled');

        $.post(window.wpajax, submitData, function (data) {
          $submitBtn.removeAttr('disabled').removeClass('disabled');
          $status.html(data).addClass('visible');
        });
      } else {
        $status
          .html('<span class="error">Please insert matching passwords</span>')
          .addClass('visible');
      }

      return false;
    });

    // Update user form
    $('form#updateUser').on('submit', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]', $form);

      if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits

      const submitData = {
        action: 'update_user',
        nonce: this.update_user_nonce.value,
        display_name: this.display_name.value,
        email: this.user_email.value,
        //language: this.user_language.value,
        pass1: this.pass1.value,
        pass2: this.pass2.value,
      };

      if (submitData.pass1 === submitData.pass2) {
        $submitBtn.attr('disabled', 'disabled').addClass('disabled');

        $.post(window.wpajax, submitData, function (data) {
          if (data === 'updated') {
            window.location.replace('?updated');
          } else {
            $submitBtn.removeAttr('disabled').removeClass('disabled');
            $status.html(data).addClass('visible');
          }
        });
      } else {
        $status
          .html('<span class="error">Please insert matching passwords</span>')
          .addClass('visible');
      }

      return false;
    });
  },
  initHeadroom() {
    const header = document.querySelector('.header__bottom');
    if (header) {
      const headroom = new Headroom(header, {
        offset: {
          up: 0,
          down: 100,
        },
      });
      headroom.init();
    }
  },
  initSession() {
    const urlParams = new URLSearchParams(window.location.search);
    const referral = urlParams.get('list');

    if (referral) {
      sessionStorage.setItem('referral', referral);
    }
  },
  initStripe($status, $submitBtn) {
    const cardWrapper = document.querySelector('#stripe-card-element');

    if (cardWrapper) {
      const purchase = {
        action: 'payreport',
      };

      // Disable the button until we have Stripe set up on the page
      $submitBtn.attr('disabled', 'disabled').addClass('disabled');
      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.wpajax,
        data: purchase,
        success: function (data) {
          $submitBtn.removeAttr('disabled').removeClass('disabled');
          const elements = app.stripe.elements();
          const style = {
            base: {
              lineHeight: '1.5',
              color: '#000000',
              fontFamily: 'ARSMaquettePro, Helvetica, Arial, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#999999',
              },
            },
            invalid: {
              fontFamily: 'ARSMaquettePro, Helvetica, Arial, sans-serif',
              color: '#ed7a5b',
              iconColor: '#ed7a5b',
            },
          };

          app.clientSecret = data.clientSecret;
          app.card = elements.create('card', { style: style });
          // Stripe injects an iframe into the DOM
          app.card.mount('#stripe-card-element');

          app.card.on('change', function (event) {
            if (event.error) {
              $status
                .html(`<span class="error">${event.error.message}</span>`)
                .addClass('visible');
            } else {
              $status.removeClass('visible');
            }
          });
        },
        error: function (error) {
          console.error(error.statusText);
          $submitBtn.removeAttr('disabled').removeClass('disabled');
        },
      });
    }
  },
  initZoomRegistration() {
    const $form = $('form#webinar-registration');

    if ($form.length > 0) {
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]', $form);

      $form.on('submit', function (e) {
        e.preventDefault();

        if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits

        const submitData = {
          action: 'zoomwebinar',
          email: this.email.value.trim(),
          first_name: this.firstname.value.trim(),
          last_name: this.lastname.value.trim(),
          webinar_id: this.webinarid.value,
          security: this.webinarsecurity.value,
        };

        if (
          submitData.firstname === '' ||
          submitData.lastname === '' ||
          submitData.email === ''
        ) {
          $status
            .html(`<span class="error">All fields are mandatory</span>`)
            .addClass('visible');
          return false;
        }

        $submitBtn.attr('disabled', 'disabled').addClass('disabled');

        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: window.wpajax,
          data: submitData,
          success: function (data) {
            console.log('Registration completed!', data);
            $form.addClass('success');
            $status.addClass('visible');

            $submitBtn.removeAttr('disabled').removeClass('disabled');
            // Reset form
            $form.trigger('reset');
          },
          error: function (error) {
            console.error(error);
            $status
              .html(
                '<span class="error">Something went wrong, please try again...</span>',
              )
              .addClass('visible');
            $submitBtn.removeAttr('disabled').removeClass('disabled');
          },
        });

        return false;
      });
    }
  },
  initNewsletterVideo() {
    const video = document.querySelector('.js-newsletter-video');
    if (video) {
      const playPromise = video.play();

      if (playPromise) {
        playPromise
          .then(function () {
            video.pause();
            let playState = null;

            const observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                  video.pause();
                  playState = false;
                } else {
                  video.play();
                  playState = true;
                }
              });
            }, {});

            observer.observe(video);

            const onVisibilityChange = () => {
              if (document.hidden || !playState) {
                video.pause();
              } else {
                video.play();
              }
            };

            document.addEventListener('visibilitychange', onVisibilityChange);
          })
          .catch(function (error) {
            console.error('Error autoplaying video', error);
          });
      }
    }
  },
  initContactForm() {
    const $form = $('form#contact-form');
    const $title = $('.js-popup-title');
    const $needInput = $('.js-need');
    const options = document.querySelectorAll('.js-contact-option');

    options.forEach((toggle) => {
      const value = toggle.getAttribute('data-value');
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        $title.text(value);
        $needInput.val(value);
      });
    });

    if ($form.length > 0) {
      const $status = $('p.status', $form).removeClass('visible');
      const $submitBtn = $('button[type=submit]');

      $form.on('submit', function (e) {
        e.preventDefault();

        if ($submitBtn.hasClass('disabled')) return false; // avoid multiple submits

        const submitData = {
          action: 'write_googlesheet_contact',
          need: this.need.value,
          interest:
            this.contactinterest_other?.value ||
            this.contactinterest?.value ||
            '',
          industry: this.contactindustry?.value || '',
          company: this.contactcompany?.value.trim() || '',
          role: this.contactrole_other?.value || this.contactrole?.value || '',
          firstname: this.contactfirstname.value.trim(),
          lastname: this.contactlastname.value.trim(),
          email: this.contactemail.value.trim(),
          message: this.message.value.trim(),
          security: this.contactsecurity.value,
          spreadsheetId: `${$form.data('sheet-id')}`,
          confirmMessage: `${$form.data('confirm-message')}`,
        };

        // Checks
        if (
          submitData.firstname === '' ||
          submitData.lastname === '' ||
          submitData.email === '' ||
          submitData.message === ''
        ) {
          $status
            .html(`<span class="error">All fields are mandatory</span>`)
            .addClass('visible');
          return false;
        }
        if (submitData.spreadsheetId === '') {
          $status
            .html(
              `<span class="error">Configuration Error. We're unable to process your request, please <a href="mailto:imminent@translated.com">contact us</a> for assistance.</span>`,
            )
            .addClass('visible');
          return false;
        }

        // Write submission to Google Sheets
        $submitBtn.attr('disabled', 'disabled').addClass('disabled');
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: window.wpajax,
          data: {
            ...submitData,
            datetime: `${new Date().toLocaleDateString('it', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
              timeZone: 'CET',
            })} ${new Date().toLocaleTimeString('it', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
              timeZone: 'CET',
            })}`,
          },
          success: function (result) {
            console.log('DEBUG --> google sheets response:', result);
            $form.addClass('success');
            $status
              .html(
                "Thank you for contacting us, we'll get back to you as soon as possible.",
              )
              .addClass('visible');
            // Close popup
            setTimeout(() => {
              if (document.body.classList.contains('popup-contact')) {
                document.body.classList.remove('popup-contact');
              }
              $form.removeClass('success');
              $status.removeClass('visible');
            }, 5000);

            // Reset form
            $submitBtn.removeAttr('disabled').removeClass('disabled');
            $form.trigger('reset');
            $form
              .find('#contactinterest')
              .val(null)
              .trigger('change')
              .trigger({
                type: 'select2:select',
                params: {
                  data: { id: null },
                },
              })
              .removeClass('selected');
            $form
              .find('#contactindustry')
              .val(null)
              .trigger('change')
              .removeClass('selected');
            $form
              .find('#contactrole')
              .val(null)
              .trigger('change')
              .trigger({
                type: 'select2:select',
                params: {
                  data: { id: null },
                },
              })
              .removeClass('selected');
          },
          error: function (error) {
            console.error(error);
            $status
              .html(
                '<span class="error">Something went wrong, please try again...</span>',
              )
              .addClass('visible');
            $submitBtn.removeAttr('disabled').removeClass('disabled');
          },
        });

        return false;
      });
    }
  },
  initGoBackToPreviousPageClick() {
    const btn = document.querySelector('#back-to-previous-page');

    btn &&
      btn.addEventListener('click', function () {
        history.go(-1);
      });
  },
  initWebGlobalizationReport() {
    const list = document.querySelector('.js-wgr-list');
    const toggle = document.querySelector('.js-wgr-toggle');

    if (list && toggle) {
      toggle.addEventListener('click', () => {
        list.classList.toggle('expanded');
        toggle.innerHTML = list.classList.contains('expanded')
          ? toggle.dataset.labelExpanded
          : toggle.dataset.labelCollapsed;
        if (!list.classList.contains('expanded')) {
          toggle.scrollIntoView(false);
        }
      });
    }

    const items = document.querySelectorAll('.js-wgr-item[data-langs]');
    const tooltip = document.querySelector('.js-wgr-tooltip');
    const tooltipText = document.querySelector('.js-wgr-tooltip-text');
    const tooltipClose = document.querySelector('.js-wgr-tooltip-close');

    if (items && tooltip && tooltipText) {
      items.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          tooltipText.innerHTML = e.currentTarget.dataset.langs;
          if (!tooltip.classList.contains('open')) {
            tooltip.classList.add('open');
          }
        });
      });
    }
    if (tooltipClose) {
      tooltipClose.addEventListener('click', (e) => {
        e.stopPropagation();
        if (tooltip) tooltip.classList.remove('open');
      });
    }
    if (tooltip) {
      tooltip.addEventListener('click', (e) => {
        e.stopPropagation();
        tooltip.classList.remove('open');
      });
    }
  },
};

$(document).ready(app.init);
